import _q from './MakeElementPayloadMessageRoomComponents'

export default {
  props: {
    query: {
      type: String,
      default: '',
    },
  },
  render: function (createElement) {
    const elements = deepMap(
      _q(this.$slots.default[0].text, this.$props.query),
      el => {
        if (!el.tag) return el

        switch (el.tag) {
          case 'strong':
            return createElement(
              el.tag,
              el.text,
            )
          case 'a':
            return createElement(
              el.tag,
              {
                attrs: {href: '#'},
                directives: [{
                  name: 'b-tooltip',
                  value: () => this.$t('room.message_email.add'),
                  modifiers: {hover: true},
                }],
                on: {
                  click: () => this.$emit('email', el.email),
                },
              },
              el.text,
            )
          default :
            return createElement(
              el.tag,
              el.text,
            )
        }
      }
    )

    return createElement(
      'span',
      {},
      elements,
    )
  }
}

function deepMap(obj, fn) {
  if (Array.isArray(obj)) {
    return obj.map(el => deepMap(el, fn))
  }
  if (obj !== null && typeof obj === 'object' && obj.hasOwnProperty('tag')) {
    return fn(obj)
  }
  return obj
}
